"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
var _isEqual = require('lodash/isEqual');
var UploadButton_1 = __importDefault(require("../../UploadButton/UploadButton"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var StyleLoader = /** @class */ (function (_super) {
    __extends(StyleLoader, _super);
    function StyleLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.parseStyle = function (uploadObject) { return __awaiter(_this, void 0, void 0, function () {
            var activeParser, file, fileContent, error_1, style, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        activeParser = this.state.activeParser;
                        if (!activeParser) {
                            return [2 /*return*/, undefined];
                        }
                        file = uploadObject.file;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.readFile(file)];
                    case 2:
                        fileContent = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        uploadObject.onError(error_1);
                        return [2 /*return*/, error_1];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, activeParser.readStyle(fileContent)];
                    case 5:
                        style = _a.sent();
                        uploadObject.onSuccess(uploadObject.file);
                        this.props.onStyleRead(style);
                        return [2 /*return*/, style];
                    case 6:
                        error_2 = _a.sent();
                        uploadObject.onError(error_2);
                        return [2 /*return*/, error_2];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.readFile = function (file) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var reader = new FileReader();
                        reader.onload = function () {
                            var fileContent = reader.result;
                            resolve(fileContent);
                        };
                        reader.onerror = reject;
                        reader.readAsText(file);
                    })];
            });
        }); };
        _this.getParserOptions = function () {
            return _this.props.parsers.map(function (parser) {
                return React.createElement(Option, { key: parser.title, value: parser.title }, parser.title);
            });
        };
        _this.onSelect = function (selection) {
            var activeParser = _this.props.parsers.find(function (parser) { return parser.title === selection; });
            if (activeParser) {
                _this.setState({ activeParser: activeParser });
            }
        };
        _this.state = {};
        return _this;
    }
    StyleLoader.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    StyleLoader.prototype.render = function () {
        var activeParser = this.state.activeParser;
        var locale = this.props.locale;
        return (React.createElement("div", { className: activeParser ? 'gs-dataloader-right' : '' },
            locale.label,
            React.createElement(antd_1.Select, { style: { width: 300 }, onSelect: this.onSelect }, this.getParserOptions()),
            activeParser ?
                React.createElement(UploadButton_1.default, { onUpload: this.parseStyle }) : null));
    };
    StyleLoader.componentName = 'StyleLoader';
    StyleLoader.defaultProps = {
        locale: en_US_1.default.GsStyleLoader,
        onStyleRead: function (style) { return; }
    };
    return StyleLoader;
}(React.Component));
exports.StyleLoader = StyleLoader;
exports.default = LocaleWrapper_1.localize(StyleLoader, StyleLoader.componentName);
//# sourceMappingURL=StyleLoader.js.map